import {FC, memo, RefObject} from 'react';
import {NeutralLink} from './styles';
import {IProjectLight} from "../../common";
import {ProjectEvents} from "../../helpers/projectEvents";
import styled from "styled-components";
import { LayoutConst } from 'core';


type ExtendedLink = {
    pathname?: string;
}
export interface ProjectCardLayoutProps extends Partial<IProjectLight>, ProjectEvents {
    disabled?: boolean;
    children?: any;
    to?: string | ExtendedLink;
    onClick?: (e: any) => void;
    span?: number;
}

const CardLinkWrapper = styled(NeutralLink)<{ span?: number }>`
  display: initial;
  grid-column: span ${({ span }) => span || 1};
  @media(max-width: ${LayoutConst.screen.s -1 + 'px'}){
    width: ${({ span }) => span === 2 ? 'calc(100vw - 20px)' : '100%'};
    grid-column: span ${({span}) => span || 1};
  }
`
const DisabledLinkWrapper = styled.span<{ span?: number }>`
  display: initial;
  grid-column: span ${({ span }) => span || 1};
  @media(max-width: ${LayoutConst.screen.s -1 + 'px'}){
    // width: ${({ span }) => span === 2 ? 'calc(100vw - 20px)' : '100%'};
    // grid-column: span 1;
  }
`

const TagLinkWrapper = styled(NeutralLink)`
    max-width: max-content;
    display: flex;
    margin: 0 !important;
`

interface LinkT extends ProjectCardLayoutProps {
    linkRef?: RefObject<any>;
    type?: string;
    title?: string;
    target?: string;
}


export const Link: FC<LinkT> = ({
    disabled,
    children,
    to,
    onClick,
    span,
    linkRef,
    type,
    title,
    target,
}) => {
    if (type === 'tag' && disabled) {
        return (
          <>
              {children}
          </>
        )
    }
    if (disabled) {
        return (
            <DisabledLinkWrapper span={span} onClick={onClick}>
                {children}
            </DisabledLinkWrapper>
        )
    }

    if (type === 'tag') {
        return (
            <TagLinkWrapper ref={linkRef} to={to} onClick={onClick} title={title} target={target}>
                {children}
            </TagLinkWrapper>
        )
    }

    return (
        <CardLinkWrapper ref={linkRef} onClick={onClick} to={to} span={span} title={title} target={target}>
            {children}
        </CardLinkWrapper>
    )
};

export default memo(Link);
import {FC, memo, RefObject} from 'react';
import {NeutralLink} from './styles';
import {IProjectLight} from "../../common";
import {ProjectEvents} from "../../helpers/projectEvents";
import styled from "styled-components";
import { LayoutConst } from 'core';


type ExtendedLink = {
    pathname?: string;
}
export interface ProjectCardLayoutProps extends Partial<IProjectLight>, ProjectEvents {
    disabled?: boolean;
    children?: any;
    to?: string | ExtendedLink;
    onClick?: (e: any) => void;
    span?: number;
}

const CardLinkWrapper = styled(NeutralLink)<{ span?: number }>`
  display: initial;
  grid-column: span ${({ span }) => span || 1};
  @media(max-width: ${LayoutConst.screen.s -1 + 'px'}){
    width: ${({ span }) => span === 2 ? 'calc(100vw - 20px)' : '100%'};
    grid-column: span ${({span}) => span || 1};
  }
`
const DisabledLinkWrapper = styled.span<{ span?: number }>`
  display: initial;
  grid-column: span ${({ span }) => span || 1};
  @media(max-width: ${LayoutConst.screen.s -1 + 'px'}){
    // width: ${({ span }) => span === 2 ? 'calc(100vw - 20px)' : '100%'};
    // grid-column: span 1;
  }
`

const TagLinkWrapper = styled(NeutralLink)`
    max-width: max-content;
    display: flex;
    margin: 0 !important;
`

interface LinkT extends ProjectCardLayoutProps {
    linkRef?: RefObject<any>;
    type?: string;
    title?: string;
    target?: string;
}


export const Link: FC<LinkT> = ({
    disabled,
    children,
    to,
    onClick,
    span,
    linkRef,
    type,
    title,
    target,
}) => {
    if (type === 'tag' && disabled) {
        return (
          <>
              {children}
          </>
        )
    }
    if (disabled) {
        return (
            <DisabledLinkWrapper span={span} onClick={onClick}>
                {children}
            </DisabledLinkWrapper>
        )
    }

    if (type === 'tag') {
        return (
            <TagLinkWrapper ref={linkRef} to={to} onClick={onClick} title={title} target={target}>
                {children}
            </TagLinkWrapper>
        )
    }

    return (
        <CardLinkWrapper ref={linkRef} onClick={onClick} to={to} span={span} title={title} target={target}>
            {children}
        </CardLinkWrapper>
    )
};

export default memo(Link);
